class PosturePromotion {
  constructor(container) {
    this.container = container;

    this.trigger = container.querySelector(
      '[data-posture-promotion-trigger]'
    );

    this.modal = container.querySelector(
      '[data-posture-promotion-modal]'
    );

    this.products = container.querySelector(
      '[data-posture-promotion-products]'
    );

    this.template = container.querySelector(
      '[data-posture-promotion-product-template]'
    );

    this.source = document.querySelector(
      '[data-posture-complementary-source]'
    );

    this.swatchAssetBase = '';

    this.settings = container.querySelector(
      '[data-posture-promotion-settings]'
    );

    if (this.settings) {
      try {
        const settings = JSON.parse(
          this.settings.textContent
        );

        this.swatchAssetBase =
          settings.swatchAssetBase || '';
      } catch (error) {
        console.log(
          'Posture Promotion: unable to read settings',
          error
        );
      }
    }

    if (
      !this.trigger ||
      !this.modal ||
      !this.products ||
      !this.template
    ) {
      return;
    }

    this.init();
  }

  init() {
    this.trigger.addEventListener('click', async () => {
      this.open();
       await this.ensureMainProductInCart();
      this.loadProducts();
    });

    this.container
      .querySelectorAll('[data-posture-promotion-close]')
      .forEach((button) => {
        button.addEventListener('click', () => {
          this.close();
        });
      });

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        this.modal.classList.contains('is-open')
      ) {
        this.close();
      }
    });
  }

  open() {
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    this.trigger.setAttribute('aria-expanded', 'true');

    document.documentElement.classList.add(
      'posture-promotion-modal-open'
    );
  }

  close() {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    this.trigger.setAttribute('aria-expanded', 'false');

    document.documentElement.classList.remove(
      'posture-promotion-modal-open'
    );
  }

  async ensureMainProductInCart() {
    const productForm = document.querySelector(
      '.product_form[data-product-id="' +
        this.container.dataset.productId +
        '"]'
    );

    if (!productForm) {
      console.log(
        'Posture Promotion: product form not found'
      );
      return;
    }

    const variantId = Number(
      productForm.dataset.variantId ||
      productForm.querySelector('[name="id"]')?.value
    );

    if (!variantId) {
      console.log(
        'Posture Promotion: main product variant not found'
      );
      return;
    }

    try {
      const cartResponse = await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );

      if (!cartResponse.ok) {
        throw new Error('Unable to load cart');
      }

      const cart = await cartResponse.json();

      const mainProductInCart = cart.items.some(
        (item) => Number(item.product_id) === Number(
          this.container.dataset.productId
        )
      );

      if (mainProductInCart) {
        return;
      }

      const addResponse = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          }),
        }
      );

      if (!addResponse.ok) {
        throw new Error(
          'Unable to add main product to cart'
        );
      }

      const updatedCartResponse = await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );

      if (!updatedCartResponse.ok) {
        return;
      }

      const updatedCart =
        await updatedCartResponse.json();

      if (typeof window.refreshCart === 'function') {
        window.refreshCart(updatedCart);
      }
    } catch (error) {
      console.error(
        'Posture Promotion: unable to add main product',
        error
      );
    }
  }

  // async loadProducts() {
  //   if (!this.source) {
  //     console.log(
  //       'Posture Promotion: complementary source not found'
  //     );
  //     return;
  //   }

  //   const sourceProducts =
  //     this.source.matches('[data-complementary-products]')
  //       ? this.source
  //       : this.source.querySelector(
  //           '[data-complementary-products]'
  //         );

  //   if (!sourceProducts) {
  //     console.log(
  //       'Posture Promotion: complementary products container not found'
  //     );
  //     return;
  //   }

  //   const productLinks = sourceProducts.querySelectorAll(
  //     'a[href*="/products/"]'
  //   );

  //   if (!productLinks.length) {
  //     console.log(
  //       'Posture Promotion: no complementary products found'
  //     );
  //     return;
  //   }

  //   this.products.innerHTML = '';

  //   const handles = [];

  //   productLinks.forEach((link) => {
  //     const url = new URL(link.href, window.location.origin);
  //     const match = url.pathname.match(
  //       /\/products\/([^/]+)/
  //     );

  //     if (match && !handles.includes(match[1])) {
  //       handles.push(match[1]);
  //     }
  //   });

  //   for (const handle of handles) {
  //     try {
  //       const response = await fetch(
  //         `/products/${handle}.js`
  //       );

  //       if (!response.ok) {
  //         continue;
  //       }

  //       const product = await response.json();

  //       this.renderProduct(product);
  //     } catch (error) {
  //       console.log(
  //         'Posture Promotion: unable to load product',
  //         handle,
  //         error
  //       );
  //     }
  //   }

  //   if (!this.products.children.length) {
  //     this.products.innerHTML =
  //       '<p class="posture-promotion__empty">No products available.</p>';
  //   }
  // }

  
  async loadProducts() {
    this.products.innerHTML = `
      <p class="posture-promotion__loading">
        Loading products...
      </p>
    `;

    try {
      if (!this.source) {
        console.warn(
          'Posture Promotion: complementary source not found'
        );
        this.showEmptyState();
        return;
      }

      const sourceProducts =
        this.source.matches('[data-complementary-products]')
          ? this.source
          : this.source.querySelector(
              '[data-complementary-products]'
            );

      if (!sourceProducts) {
        console.warn(
          'Posture Promotion: complementary products container not found'
        );
        this.showEmptyState();
        return;
      }

      const productLinks = sourceProducts.querySelectorAll(
        'a[href*="/products/"]'
      );

      const handles = [];

      productLinks.forEach((link) => {
        const url = new URL(
          link.href,
          window.location.origin
        );

        const match = url.pathname.match(
          /\/products\/([^/]+)/
        );

        if (match && !handles.includes(match[1])) {
          handles.push(match[1]);
        }
      });

      
      if (!handles.length) {
        this.showEmptyState();
        this.trigger.hidden = true;
        this.close();
        return;
      }


      this.products.innerHTML = '';

      for (const handle of handles) {
        try {
          const response = await fetch(
            `/products/${handle}.js`
          );

          if (!response.ok) {
            console.warn(
              'Posture Promotion: unable to load product',
              handle
            );
            continue;
          }

          const product = await response.json();

          this.renderProduct(product);
        } catch (error) {
          console.error(
            'Posture Promotion: unable to load product',
            handle,
            error
          );
        }
      }

      if (!this.products.querySelector(
        '[data-posture-promotion-product]'
      )) {
        this.showEmptyState();
        return;
      }

      // Keep every recommendation visible.
      // Only update its button according to cart status.
      await this.refreshProductCartStates();

    } catch (error) {
      console.error(
        'Posture Promotion: unable to load recommendations',
        error
      );

      this.showEmptyState(
        'Unable to load recommendations. Please try again.'
      );
    }
  }

  
  showEmptyState(
    message = 'No products available.'
  ) {
    this.products.innerHTML = '';

    const emptyMessage = document.createElement('p');
    emptyMessage.className = 'posture-promotion__empty';
    emptyMessage.textContent = message;

    this.products.appendChild(emptyMessage);
  }

  async refreshProductCartStates() {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      const cart = await response.json();

      this.updateProductCartStates(cart);

      return cart;
    } catch (error) {
      console.error(
        'Posture Promotion: unable to refresh product cart states',
        error
      );

      return null;
    }
  }

  updateProductCartStates(cart) {
    const cartProductIds = new Set(
      cart.items.map((item) => Number(item.product_id))
    );

    this.products
      .querySelectorAll('[data-posture-promotion-product]')
      .forEach((card) => {
        const productId = Number(card.dataset.productId);
        const variantId = Number(card.dataset.variantId);

        const button = card.querySelector(
          '[data-product-add]'
        );

        if (!button) return;

        // An invalid or unavailable variant cannot be added.
        if (!variantId) {
          button.disabled = true;
          button.textContent = 'UNAVAILABLE';
          return;
        }

        const isInCart = cartProductIds.has(productId);

        if (isInCart) {
          button.disabled = true;
          button.textContent = 'ADDED TO CART';
        } else {
          button.disabled = false;
          button.textContent = 'ADD TO CART';
        }
      });
  }



  renderProduct(product) {
    const card =
      this.template.content.firstElementChild.cloneNode(true);

    const image = card.querySelector(
      '[data-product-image]'
    );

    const title = card.querySelector(
      '[data-product-title]'
    );

    const price = card.querySelector(
      '[data-product-price]'
    );

    const options = card.querySelector(
      '[data-product-options]'
    );

    const addButton = card.querySelector(
      '[data-product-add]'
    );

    const firstAvailableVariant =
      product.variants.find(
        (variant) => variant.available
      ) || product.variants[0];

    if (!firstAvailableVariant) {
      return;
    }

    card.dataset.productId = product.id;
    card.dataset.variantId = firstAvailableVariant.id;
    card.dataset.selectedOptions = JSON.stringify(firstAvailableVariant.options);

    if (product.featured_image) {
      image.src = product.featured_image;
      image.alt = product.title;
    }

    title.textContent = product.title;
    title.href = product.url;

    const originalPrice =
      price.querySelector('[data-product-original-price]');

    const promoPrice =
      price.querySelector('[data-product-promo-price]');

    if (originalPrice && promoPrice) {
      originalPrice.textContent =
        this.formatMoney(firstAvailableVariant.price);

      promoPrice.textContent =
        this.formatMoney(
          this.getPromoPrice(
            firstAvailableVariant.price
          )
        );
    }

    this.renderOptions(
      card,
      product,
      firstAvailableVariant
    );

    addButton.addEventListener('click', () => {
      this.addToCart(
        card,
        product,
        addButton
      );
    });

    this.products.appendChild(card);
  }

  getPromoPrice(price) {
    return Math.round(price * 0.85);
  }

  renderOptions(card, product, selectedVariant) {
    const container = card.querySelector(
      '[data-product-options]'
    );

    if (!product.options || !product.options.length) {
      return;
    }

    product.options.forEach((option, optionIndex) => {
      if (
        option.name === 'Title' &&
        product.variants.length === 1
      ) {
        return;
      }

      const isColor =
        option.name.toLowerCase().includes('color') ||
        option.name.toLowerCase().includes('colour');

      const wrapper = document.createElement('div');
      wrapper.className = 'posture-promotion__option';

      const label = document.createElement('div');
      label.className =
        'posture-promotion__option-label';
      label.textContent = option.name;

      const values = document.createElement('div');
      values.className =
        'posture-promotion__option-values';

      const uniqueValues = [
        ...new Set(
          product.variants.map(
            (variant) => variant.options[optionIndex]
          )
        ),
      ];

      uniqueValues.forEach((value) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.className =
          'posture-promotion__option-value';

        if (isColor) {
          button.classList.add(
            'posture-promotion__color-swatch',
            'swatch-element',
            'color'
          );

          button.setAttribute('aria-label', value);
          button.setAttribute('title', value);

          const tooltip =
            document.createElement('span');

          tooltip.className = 'tooltip';
          tooltip.textContent = value;

          const swatch =
            document.createElement('span');

          swatch.className =
            'posture-promotion__color-swatch-label';

          const handle =
            this.getSwatchHandle(value);

          const swatchAsset =
            this.getSwatchAsset(handle);

          if (swatchAsset) {
            swatch.style.backgroundImage =
              `url("${swatchAsset}")`;
          }

          swatch.style.backgroundColor =
            value
              .split(' ')
              .pop()
              .toLowerCase();

          const crossedOut =
            document.createElement('img');

          crossedOut.className = 'crossed-out';

          crossedOut.src =
            this.getSoldOutImage();

          crossedOut.alt = '';

          swatch.appendChild(crossedOut);

          button.appendChild(tooltip);
          button.appendChild(swatch);
        } else {
          button.textContent = value;
          const crossedOut = document.createElement('img');

          crossedOut.className = 'crossed-out';
          crossedOut.src =
            this.getSoldOutImage();
          crossedOut.alt = '';

          button.appendChild(crossedOut);
        }

        // Only disable the option if there is no
        // variant with this option value at all.
        const variantExists =
          product.variants.some(
            (item) =>
              item.options[optionIndex] === value
          );

        if (!variantExists) {
          // button.disabled = true;
          button.classList.add('is-sold-out');
        }

        if (
          selectedVariant.options[optionIndex] ===
          value
        ) {
          button.classList.add('is-selected');
        }

        button.addEventListener('click', () => {
          this.selectOption(
            card,
            product,
            optionIndex,
            value
          );
        });

        values.appendChild(button);
      });

      wrapper.appendChild(label);
      wrapper.appendChild(values);

      container.appendChild(wrapper);
    });

    this.updateOptionAvailability(
      card,
      product,
      selectedVariant.options
    );
  }

  selectOption(
    card,
    product,
    optionIndex,
    value
  ) {
    let selectedOptions;

    try {
      selectedOptions = JSON.parse(
        card.dataset.selectedOptions
      );
    } catch (error) {
      const currentVariantId =
        Number(card.dataset.variantId);

      const currentVariant =
        product.variants.find(
          (variant) =>
            variant.id === currentVariantId
        );

      if (!currentVariant) {
        return;
      }

      selectedOptions = [
        ...currentVariant.options,
      ];
    }

    // Update the selected option
    selectedOptions[optionIndex] = value;

    // Save the selected options even if
    // the exact combination doesn't exist.
    card.dataset.selectedOptions =
      JSON.stringify(selectedOptions);

    // Find the exact selected variant.
    const variant = product.variants.find(
      (item) =>
        item.options.every(
          (option, index) =>
            option === selectedOptions[index]
        )
    );

    // Update selected option states
    card
      .querySelectorAll(
        '.posture-promotion__option-value'
      )
      .forEach((button) => {
        button.classList.remove(
          'is-selected'
        );
      });

    product.options.forEach(
      (option, index) => {
        const selectedValue =
          selectedOptions[index];

        card
          .querySelectorAll(
            '.posture-promotion__option'
          )
          [index]
          ?.querySelectorAll(
            '.posture-promotion__option-value'
          )
          .forEach((button) => {
            const buttonValue =
              button.dataset.value ||
              button.getAttribute('aria-label') ||
              button.textContent;

            if (
              buttonValue === selectedValue
            ) {
              button.classList.add(
                'is-selected'
              );
            }
          });
      }
    );

    // No exact variant exists for this
    // combination.
    if (!variant) {
      card.dataset.variantId = '';

      const addButton = card.querySelector(
        '[data-product-add]'
      );

      if (addButton) {
        addButton.disabled = true;
        addButton.textContent =
          'UNAVAILABLE';
      }

      this.updateOptionAvailability(
        card,
        product,
        selectedOptions
      );

      return;
    }

    // Exact variant exists.
    card.dataset.variantId = variant.id;

    // Update product image
    const image = card.querySelector(
      '[data-product-image]'
    );

    if (
      image &&
      variant.featured_image
    ) {
      image.src =
        variant.featured_image.src;
    }

    // Update price
    const price = card.querySelector(
      '[data-product-price]'
    );

    const originalPrice =
      price.querySelector(
        '[data-product-original-price]'
      );

    const promoPrice =
      price.querySelector(
        '[data-product-promo-price]'
      );

    if (originalPrice && promoPrice) {
      originalPrice.textContent =
        this.formatMoney(variant.price);

      promoPrice.textContent =
        this.formatMoney(
          this.getPromoPrice(variant.price)
        );
    }

    // Update Add to Cart button
    const addButton = card.querySelector(
      '[data-product-add]'
    );

    if (addButton) {
      if (!variant.available) {
        addButton.disabled = true;
        addButton.textContent = 'UNAVAILABLE';
      } else {
        this.refreshProductCartStates();
      }
    }

    this.updateOptionAvailability(
      card,
      product,
      selectedOptions
    );
  }

  getSwatchImage(value) {
    if (!this.swatchAssetBase) {
      return '';
    }

    const handle = value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return this.swatchAssetBase.replace(
      'SWATCH_PLACEHOLDER',
      handle
    );
  }

  getSwatchHandle(value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  getSwatchAsset(handle) {
    const assetUrl =
      document.querySelector(
        '[data-posture-promotion]'
      )?.dataset.swatchAsset;

    if (!assetUrl) {
      return '';
    }

    return assetUrl.replace(
      'SWATCH_PLACEHOLDER.png',
      `${handle}.png`
    );
  }

  getSoldOutImage() {
    const assetUrl =
      document.querySelector(
        '[data-posture-promotion]'
      )?.dataset.soldoutAsset;

    return assetUrl || '';
  }

  // async addToCart(card, product, button) {
  //   const variantId =
  //     Number(card.dataset.variantId);

  //   if (!variantId) {
  //     return;
  //   }

  //   button.disabled = true;

  //   try {
  //     const response = await fetch(
  //       `${window.Shopify.routes.root}cart/add.js`,
  //       {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type':
  //             'application/json',
  //           Accept:
  //             'application/json',
  //         },
  //         body: JSON.stringify({
  //           items: [
  //             {
  //               id: variantId,
  //               quantity: 1,
  //             },
  //           ],
  //         }),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(
  //         'Unable to add product to cart'
  //       );
  //     }

  //     // Get the updated cart
  //     const cartResponse = await fetch(
  //       `${window.Shopify.routes.root}cart.js`,
  //       {
  //         headers: {
  //           Accept:
  //             'application/json',
  //         },
  //       }
  //     );

  //     if (cartResponse.ok) {
  //       const cart =
  //         await cartResponse.json();

  //       // Use the theme's existing cart refresh
  //       if (
  //         typeof refreshCart ===
  //         'function'
  //       ) {
  //         window.refreshCart(cart);
  //       }
  //     }

  //     button.textContent = 'ADDED';

  //     setTimeout(() => {
  //       button.textContent = 'ADD TO CART';
  //       button.disabled = false;
  //     }, 1500);
  //   } catch (error) {
  //     console.error(
  //       'Posture Promotion: add to cart failed',
  //       error
  //     );

  //     button.textContent = 'TRY AGAIN';
  //     button.disabled = false;
  //   }
  // }

  
  async addToCart(card, product, button) {
    const variantId = Number(card.dataset.variantId);

    if (!variantId || button.disabled) {
      return;
    }

    button.disabled = true;
    button.textContent = 'ADDING...';

    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          }),
        }
      );

      if (!response.ok) {
        throw new Error('Unable to add product to cart');
      }

      // Refresh the theme cart and all recommendation buttons.
      const cart = await this.refreshProductCartStates();

      if (cart && typeof window.refreshCart === 'function') {
        window.refreshCart(cart);
      }

      // The add request succeeded, so retain the added state
      // even if fetching the updated cart failed.
      button.textContent = 'ADDED TO CART';
      button.disabled = true;

    } catch (error) {
      console.error(
        'Posture Promotion: add to cart failed',
        error
      );

      button.textContent = 'TRY AGAIN';
      button.disabled = false;
    }
  }


  formatMoney(cents) {
    return new Intl.NumberFormat(
      undefined,
      {
        style: 'currency',
        currency:
          window.Shopify?.currency?.active ||
          'USD',
      }
    ).format(cents / 100);
  }

  updateOptionAvailability(
    card,
    product,
    selectedOptions
  ) {
    product.options.forEach(
      (option, optionIndex) => {
        card
          .querySelectorAll(
            '.posture-promotion__option'
          )
          [optionIndex]
          ?.querySelectorAll(
            '.posture-promotion__option-value'
          )
          .forEach((button) => {
            const buttonValue =
              button.dataset.value ||
              button.getAttribute('aria-label') ||
              button.textContent;

            const hasAvailableVariant =
              product.variants.some(
                (variant) => {
                  if (!variant.available) {
                    return false;
                  }

                  return variant.options.every(
                    (
                      variantValue,
                      index
                    ) => {
                      if (
                        index === optionIndex
                      ) {
                        return (
                          variantValue ===
                          buttonValue
                        );
                      }

                      return (
                        variantValue ===
                        selectedOptions[index]
                      );
                    }
                  );
                }
              );

            const isSelected =
              selectedOptions[
                optionIndex
              ] === buttonValue;

            // Selected values should remain
            // clickable even if unavailable,
            // so the customer can change another
            // option.
            if (
              isSelected &&
              !hasAvailableVariant
            ) {
              // button.disabled = false;
              button.classList.add(
                'is-sold-out'
              );
              return;
            }

            if (!hasAvailableVariant) {
              // button.disabled = true;
              button.classList.add(
                'is-sold-out'
              );
            } else {
              // button.disabled = false;
              button.classList.remove(
                'is-sold-out'
              );
            }
          });
      }
    );
  }
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    document
      .querySelectorAll(
        '[data-posture-promotion]'
      )
      .forEach((container) => {
        new PosturePromotion(container);
      });
  }
);